/**
 * @CODE:SPEC-UTM-001 - Cart UTM Attribute Extension
 * Extends cart.js to preserve UTM attributes during cart updates
 *
 * This script intercepts cart API calls and includes stored UTM data as attributes
 * Supports both JSON and FormData request bodies
 */

(function(window, document) {
  'use strict';

  // Flag to prevent duplicate UTM updates
  let isUpdatingAttributes = false;

  /**
   * Update cart attributes with UTM data via separate API call
   * This is more reliable than intercepting the original request
   */
  function updateCartWithUTM() {
    if (isUpdatingAttributes || !window.UTMTracker) return;

    const utmAttributes = window.UTMTracker.getCartAttributes();
    if (Object.keys(utmAttributes).length === 0) return;

    isUpdatingAttributes = true;

    // Use /cart/update.js to set attributes separately
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        attributes: utmAttributes
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('[Cart UTM Extension] UTM attributes added to cart:', utmAttributes);
    })
    .catch(error => {
      console.warn('[Cart UTM Extension] Failed to update cart attributes:', error);
    })
    .finally(() => {
      isUpdatingAttributes = false;
    });
  }

  // Store original fetch to detect cart operations
  const originalFetch = window.fetch;

  // Intercept fetch calls to detect cart add/update operations
  window.fetch = function(...args) {
    const [resource, config] = args;
    const resourceStr = typeof resource === 'string' ? resource : resource.url || '';

    // Detect cart add or change operations
    const isCartAdd = resourceStr.includes('/cart/add');
    const isCartChange = resourceStr.includes('/cart/change');

    if (isCartAdd || isCartChange) {
      // Call original fetch first, then update UTM attributes after success
      return originalFetch.apply(this, args).then(response => {
        // Clone response so we can read it and still return it
        const clonedResponse = response.clone();

        // After successful cart operation, update UTM attributes
        if (response.ok) {
          // Small delay to ensure cart is updated
          setTimeout(updateCartWithUTM, 100);
        }

        return response;
      });
    }

    // For /cart/update.js calls that we initiated, skip interception
    if (resourceStr.includes('/cart/update') && isUpdatingAttributes) {
      return originalFetch.apply(this, args);
    }

    return originalFetch.apply(this, args);
  };

  // Also update UTM when cart drawer opens or cart page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Check if we're on cart page
      if (window.location.pathname.includes('/cart')) {
        setTimeout(updateCartWithUTM, 500);
      }
    });
  } else {
    if (window.location.pathname.includes('/cart')) {
      setTimeout(updateCartWithUTM, 500);
    }
  }

  // Listen for cart drawer open events (common in Shopify themes)
  document.addEventListener('click', function(e) {
    const target = e.target.closest('[data-cart-toggle], .cart-toggle, [href="/cart"]');
    if (target) {
      setTimeout(updateCartWithUTM, 500);
    }
  });

})(window, document);
